<template>
  <!-- 大题型--针对完型填空、阅读理解、选词填空 -->
  <div>
    <!-- <div class="que_box" v-for="item in answersArr" :key="item.orders"> -->
      <!-- 题干 -->
      <div>
        {{ item.orders }}、 <span v-html="item.titleHtml"></span> ({{
          item.score
        }}分)
      </div>
      <!-- 答案 -->
      <ul class="ans_ul">
        <li class="block">
          正确答案：<span
            class="green_font"
            v-html="
              item.answerss && item.answerss.shortAnswers
                ? item.answerss.shortAnswers
                : '无'
            "
          ></span>
        </li>
        <li class="block">
          考生作答：<span
            :class="
              item.answerss &&
              item.answerss.shortAnswers &&
              item.answerss.userAnswers &&
              item.answerss.shortAnswers == item.answerss.userAnswers
                ? 'green_font'
                : 'red_font'
            "
            >{{
              item.answerss && item.answerss.userAnswers&& item.answerss.userAnswers!=''&& item.answerss.userAnswers!='null'&& item.answerss.userAnswers!='undefined'
                ? item.answerss.userAnswers
                : "未作答"
            }}</span
          >
        </li>
      </ul>
      <!-- 教师评分： -->
      <ul class="teacher_score">
        <li>
          教师评分：
          <el-input
            style="width: 30%"
            type="number"
            v-model="item.teacherScore"
            @input="inputFunc(item.orders, item.teacherScore)"
          >
          </el-input>
          分
        </li>
        <li>
          教师评语：
          <el-input
            style="width: 86%"
            type="text"
            placeholder="请输入本题评语（可以留空）"
            v-model="item.comment"
            maxlength="100"
            show-word-limit
          >
          </el-input>
        </li>
      </ul>
    </div>
  <!-- </div> -->
</template>

<script>
export default {
  name: "AnswersType",
  props: {
    // answersArr: Array,
    item: Object
  },
  created() {
    // this.answersArr.forEach((item) => {
      this.item.titleHtml = this.item.titleHtml.replace(
        /<img/g,
        "<img style='width:80px;height:auto;'"
      );
      if (this.item.answerss.shortAnswers) {
        this.item.answerss.shortAnswers = this.item.answerss.shortAnswers.replace(
          /<img/g,
          "<img style='width:80px;height:auto;'"
        );
      }
    // });
  },
  watch: {
    answersArr: {
      handler(newValue) {
        this.$emit("change-answers", newValue);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    inputFunc(index, val) {
      // 判断当前是哪个input输入框改变
      // this.answersArr.map((item) => {
        if (this.item.orders == index) {
          if (val > this.item.score) {
            this.$alert(
              "亲:试题分数不能大于[试题满分]请重新评分！",
              "友情提示",
              {
                confirmButtonText: "确定",
                callback: (action) => {
                  this.item.teacherScore = 0;
                },
              }
            );
            return false;
          }
        }
      // });
    },
  },
};
</script>

<style scoped>
</style>